<div class="h-100">
  <div
    class="flex align-items-center w-100 border--bottom-grey padding-xxl-20"
    [ngClass]="{ 'ship-to-tab': activeTab === 'ClientLocations', 'ship-from-tab': activeTab === 'InnerLocations' }"
  >
    <div
      *ngIf="activeTab === 'ClientLocations' && hasPermissionToSeeClients"
      class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20"
    >
      Client name
    </div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Location name</div>
    <div *ngIf="activeTab !== 'ClientLocations'" class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">
      Gates
    </div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Address</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-20">Postal code</div>
    <div class="font--xxl-11 font-500 color-sky-blue margin-xxl--right-52">City</div>
    <div class="flex-1 font--xxl-11 font-500 color-sky-blue">Country</div>
  </div>
  <div class="body-all overflow-y--scroll">
    <app-pagination-scroll-with-button
            [isLoading]="isLoading"
            [canLoadMore]="canLoadMore"
            [perPage]="10"
            (loadMore)="onLoadMore($event)"
            style="width: 100%"
            #pagination
    >
      <div *ngIf="list && list.length > 0 && !isLoading" class="h-100">
        <div
                *ngFor="let location of list"
                class="flex align-items-center body-all-one border--bottom-grey position-relative padding-xxl-20"
                [ngClass]="{ 'ship-to-tab': activeTab === 'ClientLocations', 'ship-from-tab': activeTab === 'InnerLocations' }"
        >
          <div
                  *ngIf="activeTab === 'ClientLocations' && hasPermissionToSeeClients"
                  class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20"
          >
            {{ location?.client?.name }}
          </div>
          <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">{{ location?.name }}</div>
          <div
                  *ngIf="activeTab !== 'ClientLocations'"
                  class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20"
          >
            {{ location?.gates?.length || 'No gates' }}
          </div>
          <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
            {{ location?.address | address }}
          </div>
          <div class="font--xxl-13 font-regular color-dark-blue margin-xxl--right-20">
            {{ location?.address?.postalCode }}
          </div>
          <div class="flex-1 font--xxl-13 font-regular color-dark-blue">
            {{ location?.address?.city }}
          </div>
          <div class="flex-1 font--xxl-13 font-regular color-dark-blue">
            {{ location?.address?.country }}
          </div>
          <div *ngIf="activeTab !== 'ClientLocations'" class="flex justify-content-end">
            <div
                    style="width: 7rem"
                    class="button-round-small color-dark-blue font--xxl-13 background-background-blue-dark margin-xxl--right-32 flex align-items-center justify-content-center"
                    (click)="onDetails(location)"
            >
              Details >
            </div>
          </div>
          <div (click)="showPopupDots(location.id)" class="cursor-pointer margin-xxl--right-25">
            <img src="/assets/images/icons/dots.svg" alt=""/>
          </div>

          <!-- dots -->
          <div
                  [ngStyle]="{
            opacity: openDots && locationId === location.id ? '1' : '0',
            'pointer-events': openDots && locationId === location.id ? 'all' : 'none'
          }"
                  (mouseleave)="openDots = false"
                  class="dots flex flex-column justify-content-center"
          >
            <div
                    (click)="onEditLocation(location)"
                    class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer"
            >
              Edit Location
            </div>
            <div
                    (click)="deleteLocation(location.id)"
                    class="option-hover font--xxl-11 font-regular color-dark-blue cursor-pointer"
            >
              Delete Location
            </div>
          </div>
        </div>
      </div>
      <!-- empty screen shipping location-->
      <div
              *ngIf="(!list || list.length === 0) && !isLoading"
              class="flex justify-content-center"
      >
        <div class="empty-screen flex flex-column align-items-center justify-content-center">
          <img class="margin-xxl--bottom-48" src="/assets/images/emptyScreen/templates.svg" alt=""/>
          <div class="font--xxl-16 font-regular text-center color-dark-blue">
            Here, you’ll find your Clients’ regular Pick-up and Delivery Locations.
          </div>
          <div class="font--xxl-16 font-regular text-center color-dark-blue margin-xxl--bottom-24">
            Saving a Client’s Location will save you a lot of time when filling in forms.
          </div>
          <div class="font--xxl-16 font-regular text-center color-dark-blue">
            Add your first Location via the Add New button in the top-right corner.
          </div>
        </div>
      </div>
    </app-pagination-scroll-with-button>
  </div>
</div>
